import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntil } from "rxjs/operators";
import { NgbModal }  from "@ng-bootstrap/ng-bootstrap";
import { Session } from "../../models/Session";
import { MasterDataService } from "../../services/masterdata.service";
import { CreateClientService } from "../../services/create-client.service";
import { Subject } from "rxjs";
import { FormControl, FormGroup } from '@angular/forms';
import { CreateOrganizationComponent } from '../create-organization/create-organization.component';
import { Router } from '@angular/router';
import { SearchRequest } from '../../models/organization-model';
import { CompaniesDTO } from '../../shared/models/companies.model';

declare let $: any;

@Component({
    selector: 'app-search-organization',
    templateUrl: './search-organization.component.html',
    styleUrls: ['./search-organization.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchOrganizationComponent implements OnInit {
    @Input() session: Session;
    @Input() public stateDisable: boolean = true;
    @Input() public dropdownData_Sectors: any = [];
    @ViewChild('content', { static: true }) private content;
    @ViewChild("ngForm") formValues;
    @ViewChild("searchFieldsHeight", { static: true }) searchFieldsHeight: ElementRef;
    addClientForm: FormGroup;
    showLoader: boolean = false;
    masterData: any;
    public clientProgram: any;
    public sessionIndustry: any;
    public sessionSector: any;
    public dropdownData: any = [];
    disableSectorNA: boolean = true;
    disableIndustryNA: boolean = true;
    clients: any = [];
    filteredClients: any = [];
    sampleColumns: any;
    DunsID: any = "";
    companyName: any = "";
    verifyCompanyRes: number = 0;
    resultModalContent: string = '';
    validForm: boolean = false;
    clientProgramList: any = [];
    industryList: any = [];
    sectorList: any = [];
    totalRecords: number = 0;
    startId: number = 1;
    endId: number = 50;
    systemDunsId: any = "";
    DunsErrorMsg: string = "";
    searchAreaFields: boolean = true;
    seaerchAreaDownArrow: boolean = false;
    seaerchAreaUpArrow: boolean = false;
    isExpandSearchFields: boolean = false;
    private subscription: Subject<void> = new Subject<void>();
    searchGridHeight: any;
    createFormValues: any;
    isSearchModify = false;
    enableSearch = false;
    isShowTable = false;
    showNAFields = false;

    constructor(
        private masterDataService: MasterDataService,
        private createClientService: CreateClientService,
        private modalService: NgbModal,
        private router: Router
    ) { }

    onScroll(event): void {
        if (this.filteredClients.length >= 50) {
          var element = document.getElementById('gridScroll');
          const atBottom = element.scrollHeight - element.scrollTop === element.clientHeight;
            if (atBottom) {
                this.startId = this.startId + 50;
                this.endId = this.endId + 50;
                this.allClients(this.startId, this.endId);
            } else {
                var clientHeight = element.scrollHeight - element.scrollTop;
                if (clientHeight >= 440 && clientHeight <= 462) {
                    this.startId = this.startId + 50;
                    this.endId = this.endId + 50;
                    this.allClients(this.startId, this.endId);
                }
            }
        }

    }

     ngOnInit(): void {
         this.showLoader = false;
         this.seaerchAreaDownArrow = false;
         this.seaerchAreaUpArrow = true;
         const searchParams = this.createClientService.searchParameters ? this.createClientService.searchParameters : {} as any;
         this.addClientForm = new FormGroup({
             CompanyName: new FormControl(searchParams.CompanyName ? searchParams.CompanyName : ''),
             DunsId: new FormControl(searchParams.DunsId ? searchParams.DunsId : ''),
             sessionIndustry: new FormControl(searchParams.sessionIndustry ? searchParams.sessionIndustry : null),
             sessionSector: new FormControl(searchParams.sessionSector ? searchParams.sessionSector : null),
             AccountHierarchy: new FormControl(searchParams.AccountHierarchy ? searchParams.AccountHierarchy : null),
             ParentAccountName: new FormControl(searchParams.ParentAccountName ? searchParams.ParentAccountName : ''),
             ParentAccountDUNS: new FormControl(searchParams.ParentAccountDUNS ? searchParams.ParentAccountDUNS : '')
         });
         this.session = new Session();
         this.getSessionData();
     }

    onResize(event) {
        if (!this.isExpandSearchFields) {
            this.searchGridHeightSet();
        } else {
            setTimeout(() => {
                var SearchFildsHeight =
                    this.searchFieldsHeight.nativeElement.offsetHeight;
                const screenHeight = window.innerHeight;
                const totalDedVal = SearchFildsHeight - 100;
                return (this.searchGridHeight = screenHeight - totalDedVal + "px");
            }, 300);
        }
    }

    getSessionData(): void {
        this.masterDataService.getMasterDataDetails().subscribe((res) => {

            this.dropdownData = JSON.parse(JSON.stringify(res));
            this.masterData = JSON.parse(JSON.stringify(res));

            this.clientProgramList = this.masterData.ClientPrograms;
            this.industryList = this.masterData.Industries;
            this.sectorList = this.masterData.Sectors;

            this.loadIndustryDropdown();

            this.loadTableData();
            const formValues = this.addClientForm.value;
            if ((formValues.CompanyName !== "" && formValues.CompanyName !== null) || formValues.DunsId !== "" ||
                formValues.sessionIndustry !== null || formValues.sessionSector !== null || 
                formValues.AccountHierarchy !== null || (formValues.ParentAccountName !== "" && formValues.ParentAccountName !== null) ||
                (formValues.ParentAccountDUNS !== "" && formValues.ParentAccountDUNS !== null)) {
                if (formValues.sessionIndustry !== null) {
                    this.session.industryid = formValues.sessionIndustry;
                    this.session.sectorid = formValues.sessionSector

                    this.dropdownData_Sectors = this.dropdownData.Sectors.filter(
                        (sector) => sector.IndustryID===formValues.sessionIndustry
                    );
                }
                this.allClients(this.startId, this.endId);
            } else {
                this.showLoader = false;
            }

        });
    }

    loadIndustryDropdown(includeNA?): void {
        if (this.masterData && this.masterData.Industries.length > 0) {
            if (includeNA) {
                this.dropdownData.Industries = this.masterData.Industries.filter(
                    (data) => !data.IsMDR && data.IsActive
                );
            } else {
                this.dropdownData.Industries = this.masterData.Industries.filter(
                    (data) => !data.IsMDR && data.IsActive && !data.Name.includes("N/A")
                );
            }
        }
    }

    onFocusOutCompany(event): void {
        this.companyName = event.target.value;
    }

    industryChange(event): void {
        this.isFieldEmpty();
        this.dropdownData_Sectors = this.dropdownData.Sectors.filter(
            (sector) => sector.IndustryID==event
        );
        this.session.sessionSector = null;
        const item = this.dropdownData.Industries.find(
            (index) => index.ID==event
        );
        this.session.sessionIndustry = item ? event : null;
        this.session.industryid = event;
        this.disableIndustryNA = true;
        if (item && item.Name.includes("N/A")) {
            this.disableIndustryNA = false;
            this.onSectorChange(this.dropdownData_Sectors[0].SectorID);
        } else {
            this.disableSectorNA = true;
        }
    }

    onSectorChange(id): void {
        this.isFieldEmpty();
        if (this.dropdownData_Sectors && this.dropdownData_Sectors.length > 0) {
            const item = this.dropdownData_Sectors.find(
                (index) => index.SectorID===id
            );
            this.disableSectorNA = true;
            if (item && item.SectorName.includes("N/A")) {
                this.disableSectorNA = false;
            }
            this.session.sessionSector = id;
            this.session.sectorid = id;
        }
    }

    allClients(startId, endId): void {
        const formValues = this.addClientForm.value;
        this.showLoader = true;
        const requestBody = {
            startID: startId,
            endID: endId,
            IndustryID: formValues.sessionIndustry,
            SectorID: formValues.sessionSector,
            Name: formValues.CompanyName,
            DunsID: formValues.DunsId,
            AccountHierarchy: formValues.AccountHierarchy,
            ParentAccountName: formValues.ParentAccountName,
            ParentAccountDunsID: formValues.ParentAccountDUNS
        }
        this.createClientService.getAllCompanyData(requestBody)
            .pipe(takeUntil(this.subscription))
            .subscribe((res: CompaniesDTO[]) => {
                this.isShowTable = true;
                if (res) {
                    res.map((result) => {
                        let clientProgram = this.clientProgramList.find(
                            (x) => x.ClientProgramID === result.ClientProgramID
                        );
                        clientProgram = clientProgram===undefined ? 'NA' : clientProgram.ClientProgramName;
                        let industry = this.industryList.find(
                            (x) => x.ID === result.IndustryID
                        );
                        industry = industry===undefined ? 'NA' : industry.Name

                        let sector = this.sectorList.find(
                            (x) => x.SectorID === result.SectorID
                        );
                        sector = sector===undefined ? 'NA' : sector.SectorName
                        this.clients.push({
                            DUNS: result.DunsID,
                            CompanyOrganization: result.Name,
                            AccountHierarchy: result.AccountHierarchy,
                            ParentAccountName: result.ParentAccountName,
                            ParentAccountDunsID: result.ParentAccountDunsID,
                            ClientProgram: clientProgram,
                            Industry: industry,
                            Sector: sector
                        });
                    });

                    this.filteredClients = JSON.parse(JSON.stringify(this.clients));

                    if (this.filteredClients.length > 0) {
                        this.isSearchModify = true;
                        this.enableSearch = true;
                        this.searchAreaCollapse();
                    } else {
                        this.isSearchModify = false;
                    }
                    this.showLoader = false;
                } else {
                    this.enableSearch = true;
                    if (startId===1) {
                        this.filteredClients = [];
                    }

                    this.showLoader = false;
                }
            });

    }

    loadTableData(): void {
        this.sampleColumns = [
            {
                name: "DUNS",
                header: "DUNS",
                dataType: "string",
                minWidth: "60px",
            },
            {
                name: "CompanyOrganization",
                header: "Company/Organization",
                dataType: "string",
                minWidth: "60px",
            },
            {
              name: "AccountHierarchy",
              header: "Account Hierarchy",
              dataType: "string",
              minWidth: "60px",
            },
            {
              name: "ParentAccountName",
              header: "Parent Account Name",
              dataType: "string",
              minWidth: "60px",
            },
            {
              name: "ParentAccountDunsID",
              header: "Parent Account DUNS",
              dataType: "string",
              minWidth: "60px",
            },
            {
                name: "ClientProgram",
                header: "Client Program",
                dataType: "string",
                minWidth: "60px",
            },
            {
                name: "Industry",
                header: "Industry",
                dataType: "string",
                minWidth: "60px",
            },
            {
                name: "Sector",
                header: "Sector",
                dataType: "string",
                minWidth: "60px",
            },
        ];
    }

    onSubmitAddCompany(flag, values) {
        this.showLoader = true;
        const data = {
            Name: values.CompanyName,
            ClientProgramID: values.clientProgram,
            DunsID: values.DunsId,
            IndustryID: values.sessionIndustry,
            SectorID: values.sessionSector,
            Flag: "INSERT"
        }
        this.showLoader = true;
        this.createClientService
            .saveData(data)
            .pipe(takeUntil(this.subscription))
            .subscribe((res) => {
                if (res) {
                    this.showLoader = false;
                    if (flag==="UPDATE") {
                        this.verifyCompanyRes = 3;
                        this.clearData();
                    }

                }
            });
        this.showLoader = false;


    }

    clearData(): void {
        this.addClientForm.reset();
        this.validForm = false;
        this.enableSearch = false;

    }

    searchGridHeightSet(): void {
        setTimeout(() => {
            var SearchFildsHeight =
                this.searchFieldsHeight.nativeElement.offsetHeight;
            const screenHeight = window.innerHeight;
            const totalDedVal = SearchFildsHeight + 230;
            return (this.searchGridHeight = screenHeight - totalDedVal + "px");
        }, 300);
    }

    searchAreaExpand(): void {
        this.searchAreaFields = true;
        this.seaerchAreaDownArrow = false;
        this.seaerchAreaUpArrow = true;
        this.searchGridHeight = "400px";
        this.isExpandSearchFields = true;
        this.isSearchModify = false;
        var element = document.getElementById('gridScroll');
        this.startId = 1;
        this.endId = 50;
        element.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    searchAreaCollapse(): void {
        this.isExpandSearchFields = false;
        this.searchAreaFields = false;
        this.seaerchAreaDownArrow = true;
        this.seaerchAreaUpArrow = false;
        this.searchGridHeightSet();
        if (this.filteredClients.length > 0) {
            this.isSearchModify = true;
        }
    }

    createOrg(): void {
        this.router.navigate(['/createClient']);
    }

    onChange(event): void {
        this.isFieldEmpty();
    }

    isFieldEmpty(): void {
        const formValues = this.addClientForm.value;
        formValues.CompanyName = formValues.CompanyName ? formValues.CompanyName.replace(/^\s+|\s+$/gm, '') : formValues.CompanyName;
        formValues.ParentAccountName = formValues.ParentAccountName ? formValues.ParentAccountName.replace(/^\s+|\s+$/gm, '') : formValues.ParentAccountName;
        formValues.ParentAccountDUNS = formValues.ParentAccountDUNS ? formValues.ParentAccountDUNS.replace(/^\s+|\s+$/gm, '') : formValues.ParentAccountDUNS;
        if ((formValues.CompanyName !== "" && formValues.CompanyName !== null) || (formValues.DunsId !== "" && formValues.DunsId !== null) ||
            (formValues.clientProgram !== null && formValues.clientProgram !== undefined) || formValues.sessionIndustry !== null || formValues.sessionSector !== null ||
            formValues.AccountHierarchy !== null || (formValues.ParentAccountName !== "" && formValues.ParentAccountName !== null) ||
            (formValues.ParentAccountDUNS !== "" && formValues.ParentAccountDUNS !== null)) {
            this.enableSearch = true;
        } else {
            this.enableSearch = false;
        }

    }

    onSearch(event): void {
        event.preventDefault();
        this.isFieldEmpty();
        if (this.isSearchModify) {
            this.searchAreaExpand();

        } else {
            if (this.enableSearch) {
                this.clients = [];
                this.createClientService.searchParameters = this.addClientForm.value;
                this.allClients(1, 50);
            }
        }
    }

    clearSearchData(): void {
        this.addClientForm.reset();
        this.searchAreaExpand();
        this.enableSearch = false;
        this.isShowTable = false;
        this.session.industryid = null;
        this.session.sectorid = null;
        this.startId = 1;
        this.endId = 50;
        this.createClientService.searchParameters = this.addClientForm.value;
    }

    acceptAlphanumericInput(event): boolean {
        return ((!event.shiftKey && event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90)
            || (event.charCode >= 97 && event.charCode <= 122)) ? true : false;
    }

}
